import React from 'react';

import { search_page_path } from '../../routes';

const SEARCH_EXAMPLES = [
  'Most promising startups',
  'Artificial intelligence regulation',
  'The future of EV batteries',
  'Crypto & the SEC',
  'Venture capital trends',
];

const SearchExamples = () => (
  <div className="tw-px-16">
    <div className="tw-max-w-[600px] tw-mx-auto tw-mt-48">
      <h2 className="tw-text-body-lg tw-font-bold tw-m-0 tw-border-solid tw-border-0 tw-border-b tw-border-gray-300">
        Example searches:
      </h2>
      <ul className="tw-m-0 tw-list-none tw-mt-12 tw-pl-4 tw-space-y-8">
        {SEARCH_EXAMPLES.map((query) => (
          <li key={query}>
            <SearchExampleLink query={query} />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const SearchExampleLink = ({ query }) => (
  <a
    href={search_page_path({ query })}
    className="hover:tw-text-primary-red tw-transition-colors tw-m-0"
  >
    <span aria-hidden="true">{'> '}</span>
    <span className="tw-sr-only">Search results for </span>
    <span className="tw-text-body-sm tw-italic">{query}</span>
  </a>
);

export default SearchExamples;
